<template>
        <div>
            <!-- <alert v-if="filial.certificado.length > 0" type="warning" :close="false" text="Certificado Configurado"></alert> -->
            <!-- <label-title v-if="filial.certificado.length > 0" title="Certificado Configurado"></label-title> -->
            <div class="row mb-3" v-if="!configurarNovoCertificado">
                <form-field type="text" v-model="certificado[0].nome" col="12" label="Certificado Emitido Para" :disabled="true"></form-field>
                <div class="col-md-12 col-12 nb-margin-top mb-3">
                    <v-button label="Excluir Certificado Atual" title="Remove o certificado vinculado atualmente" icon="fa-trash" :nb-btdef="true" @click="handleDeleteFile"></v-button>
                    <v-button v-if="!filial.certificado[0].filename" label="Atualizar Nota Brasil A3" :nb-btdef="true" @click="handleDownloadA3"></v-button>
                    <!-- <v-button label="Configurar Um Novo" title="Configurar novo certificado A1" @click="configurarNovoCertificado = true"></v-button> -->
                </div>
            </div>

            <div class="row nb-margin-top mb-3" v-if="configurarNovoCertificado">
                <form-field v-model="selectedFile.name" type="text" col="12" label="Arquivo" :disabled="true"></form-field>
                <div class="col-md-12 col-12 mb-3">
                    <v-button label="Selecionar Arquivo" :nb-btdef="true" icon="fa-folder" @click="handleFileSelectBtn()"></v-button>
                </div>
                <form-field ref="senha" v-model="senha1" type="password" col="12" label="Senha" @key.enter="handleSend()"></form-field>
                <div v-if="message" class="col-md-12 col-12 mb-3">
                    <span class="error">{{ message }}</span>
                </div>
                <div class="col-md-12 col-12 mb-3">
                    <v-button v-if="selectedFile.name" label="Enviar Certificado" :nb-btdef="true" @click="handleSend()"></v-button>
                </div>
            </div>

            <div v-show="false">
                <input type="file" ref="file" accept=".pfx" @change="handleFileUpload()">
            </div>

        </div>
</template>

<script>

import { SysVars } from '../main'
import { getText, formatDate, formatValue } from '../shared/utils'
import axios from 'axios'
import { apiORDS, apiORDSpost, apiORDSdelete, urlORDS } from '../shared/api-functions'

export default {
    props: {
        filial: {},
    },

    data() {
        return {
            certificado: [],
            metadata: this.$store.getters.getEntities.metadata,
            message: null,  //armazena as mensagens de validacao do servidor para mostrar em tela
            selectedFile: {},
            urlFile: '',
            url: urlORDS(this.$store, 'certificado/'),
            imageStatus: 'empty',
            senha1: '',
            tipoCertificado: 'A1',
            configurarNovoCertificado: true,
        }
    },

    computed: {
        status: function () {
            return ''
        }
    },

    methods: {
        data (value) {
            return formatDate(value)
        },        

        closeForm () {
            this.$emit('closeform')
        },

        uploadCert(){
            //EFETUA O UPLOAD DO CERTIFICADO

            let formData = new FormData();
            formData.append('file', this.selectedFile);

            var self = this
            this.message = null

            axios.post(this.url, formData,
                { 
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'filial': this.filial.codfil,
                    'password': this.senha1,
                    'filename': this.selectedFile.name,
                    'tpcertificado': 'A1',
                }
            }
            ).then(function(data){
                    if (data.data.result == 'error') {                      
                      self.message = data.data.message                       
                      //self.$erpToastError(data.data.message)
                      return
                    }
                    self.imageStatus = 'ok'
                    // if (data.items) {
                    //     self.certificado = data.items
                    // }
                    self.$store.dispatch('loadSessao', self) //ATUALIZA A SESSAO COM O CERTIFICADO INSTALADO
                    self.$erpToastSuccess('O certificado foi atualizado com sucesso.')
                    self.$emit('refresh')
                })
                .catch(function(data){
                    self.imageStatus = 'error'
                })
        },

        handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVO
            this.$refs.file.click()
        },

        handleSend() {
            if (this.senha1 == '') {
                alert('Informe a senha')
                return
            }
            if (!this.selectedFile.name) {
                this.$erpToastError('Selecione um arquivo para continuar')
                return
            }
            this.uploadCert()
        },

        handleDeleteFile() {
            //REMOVE O CERTIFICADO
            this.selectedFile = {}
            if (this.certificado.length > 0) {
                this.apiDelete()
            }
        },

        handleFileUpload () {
            //EVENTO AO SELECIONAR ARQUIVO
            this.selectedFile = this.$refs.file.files[0]
            this.$nextTick(function () {
                this.$refs.senha.focus()
            })

        },

        handleDownloadA3 () {
            window.open('https://novo.notabrasil.com.br/com.notabrasil.a3.exe', "_blank")
        },

        async loadData () {
            //CARREGA OS DADOS DO CERTIFICADO DA FILIAL
            this.certificado = []
            this.configurarNovoCertificado = this.filial.certificado.length == 0
            if (this.filial.certificado.length > 0) {
              const data = await apiORDS(this.url + this.filial.certificado[0].codcertificado, {})
              if (data.items) {
                 this.certificado = data.items
              }
            }
        },

        async apiDelete () {
            //EFETUA A EXCLUSAO DO CERTIFICADO
            var modulo = 'certificado/' + this.certificado[0].codcertificado
            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastSuccess('O certificado foi removido com sucesso.')
            this.certificado = []
            this.$emit('refresh')
        },

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.loadData()
        this.selectedFile = ''  
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/app-certificado-form.vue